/* eslint-disable camelcase */
import * as NOTES_ACTION from 'js/constant/action/notes'
import { createAction } from 'redux-actions'
import _ from 'lodash'
import { getSavedUrls, saveNewUrl, deleteSavedUrl } from 'js/redux/api/notes'
import { v4 as uuidv4 } from 'uuid'
import { Auth } from 'aws-amplify'


const updateLoader = createAction(NOTES_ACTION.UPDATE_NOTES_LOADER)
const updateNotesData = createAction(NOTES_ACTION.UPDATE_NOTES_DATA)

export const getQueries = () => async (dispatch, getState) => {

  console.log("Getting the saved URLs...")
  
  try {
    const {
      auth: { userDetails }
    } = await getState()
    dispatch(updateLoader(true))

    var credentials = await Auth.currentCredentials();

    const savedUrls = await getSavedUrls(credentials.identityId)
    console.log("Saved URLs: ", savedUrls)
    for (var savedUrl of savedUrls) {
      if (!savedUrl.url.includes("/explorer?params=")) {
        savedUrl.url = decodeURIComponent(savedUrl.url)
      }
    }
    dispatch(updateNotesData(savedUrls))
    dispatch(updateLoader(false))
  } catch (error) {
    console.error(error)
    dispatch(updateLoader(false))
  }
  
}

export const setSavedQueries =
(queryToAdd, deleteBool) =>
  async (dispatch, getState) => {
    try {
      const {
        notes: { notesData }
      } = await getState()
      dispatch(updateLoader(true))

      if (deleteBool) {
        dispatch(updateNotesData(queryToAdd))
      } else {
        dispatch(updateNotesData(!_.isEmpty(notesData) ? [...notesData, notesData] : queryToAdd))
      }

      dispatch(updateLoader(false))
    } catch (error) {
      dispatch(updateLoader(false))
      console.error(error)
    }
  }

export const addQuery =
  (data) =>
    async (dispatch, getState) => {
      try {
        const {
          auth: { userDetails }
        } = await getState()
        const entryId = uuidv4()
        const current = new Date()
        const date = new Intl.DateTimeFormat('en-GB').format(current)

        var credentials = await Auth.currentCredentials();
        await saveNewUrl(date, entryId, credentials.identityId, data.title, data.url, data.description, data.hash)
        getQueries()
      } catch (error) {
        console.error(error)
      }
    }

export const updateQuery =
  (data) =>
    async (dispatch, getState, { notes }) => {
      try {
        await saveNewUrl(data.date, data.id, data.user_id, data.title, data.url, data.description, data.hash)
        getQueries()
      } catch (error) {
        console.error(error)
      }
    }

export const deleteQuery = (data) => async (dispatch, getState, { notes }) => {
  try {
    var credentials = await Auth.currentCredentials();
    await deleteSavedUrl(data.id, credentials.identityId)
    getQueries()
  } catch (error) {
    console.error(error)
  }
}